import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { initialDocListState } from "./document-list.state";
import { DocListCurrentPageDetails } from "../../models/document-list-state.model";

const documentListSlice = createSlice({
  name: "documentsList",
  initialState: initialDocListState,
  reducers: {
    setCurrentPageDetails: (
      state,
      { payload }: PayloadAction<DocListCurrentPageDetails>
    ) => {
      state.currentPageDetails = payload;
    }
  }
});

export default documentListSlice.reducer;
export const documentListActions = documentListSlice.actions;
